/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(examId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetExternalExamTaskDetails: {
        $xmlns: 'http://dobs.pa.gov/sc/task/bpm/1.0',
        ExamID: examId
      }
    },
    blueprintArrays: [
      'GetExternalExamTaskDetailsResponse.SC_ExamSubsequentRequestDocument',
      'GetExternalExamTaskDetailsResponse.CM_Document'
    ],
    blueprint: {
      examId: '$..ExamID',
      examNumber: '$..ExamNumber',
      crdNumber: '$..CRDNumber',
      branchCrdNumber: '$..BranchCRDNumber',
      dbaName: '$..DBAName',
      applicantLegalName: '$..ApplicantLegalName',
      rfiExternalComments: '$..RFIExternalComments',
      subReqExternalComments: '$..SubReqExternalComments',
      rfiRequestDocument: {
        fileId: '$..RFIRequestDocID',
        fileName: '$..RFIRequestName'
      },
      subsequentRequestDocuments: [
        '$..SC_ExamSubsequentRequestDocument',
        {
          fileId: '$.DocumentID',
          fileName: '$.Name'
        }
      ],
      rfiRequestDocuments: [
        '$..CM_Document',
        {
          fileId: '$.RFIRequestDocID',
          fileName: '$.Name'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      response.branchCrdNumber = response.branchCrdNumber || '--';
      deferred.resolve(response);
    })
    .fail(function() {
      deferred.reject();
    });

  return deferred.promise();
};
